import { render, staticRenderFns } from "./addAnnounce.vue?vue&type=template&id=10a0acf0&scoped=true"
import script from "./addAnnounce.vue?vue&type=script&lang=js"
export * from "./addAnnounce.vue?vue&type=script&lang=js"
import style0 from "./addAnnounce.vue?vue&type=style&index=0&id=10a0acf0&prod&lang=less&scoped=true"
import style1 from "./addAnnounce.vue?vue&type=style&index=1&id=10a0acf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0acf0",
  null
  
)

export default component.exports